import { render, staticRenderFns } from "./customize.vue?vue&type=template&id=6c55a798&scoped=true"
import script from "./customize.vue?vue&type=script&lang=js"
export * from "./customize.vue?vue&type=script&lang=js"
import style0 from "./customize.vue?vue&type=style&index=0&id=6c55a798&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c55a798",
  null
  
)

export default component.exports